export const INITIAL_DATA_REQUEST = {
    pageSize: 5,
    page: 1,
}

export const VEDMARKET_LINKS = {
    login: 'https://my.vedmarket.ru/login',
    demo: 'https://my.vedmarket.ru/demo',
    calculator: 'https://my.vedmarket.ru/cabinet/calculator',
} as const;
